// extracted by mini-css-extract-plugin
export default {"container":"entities_card_footer-module__container--zUBGW"};